export default __webpack_public_path__ + "static/media/wallet.a4113777.svg";